var map = {
	"./tab1_1.png": 620,
	"./tab1_2.png": 621,
	"./tab2_1.png": 622,
	"./tab2_2.png": 623,
	"./tab2_3.png": 624,
	"./tab3_1.png": 625,
	"./tab3_2.png": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3529;